import { React, useEffect, useState } from 'react';
import DetailsContainer from './DetailsContainer';
import { useLocation, useParams } from 'react-router-dom';
import DetailsActualsContainer from './DetailsActualsContainer';
import PlannedActualsService from '../../services/PlannedActualsService';
import FieldNames from '../../defaults/FieldNames.json';
import ActionCategoryAssociations from '../../defaults/ActionCategoryAssociations.json';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useSelector } from 'react-redux';
import Events from '../../defaults/Events';
import { emitCustomEvent } from 'react-custom-events';
import GroupingService from '../../services/GroupingService';
import FundingService from '../../services/FundingService';
import { createFutureActualFeature, isFeaturePostFire } from '../../utils/FeatureHelper';
import { v4 as uuidv4 } from 'uuid';
import ErrorService from '../../services/ErrorService';
import { useIFPRSGlobalContext } from '../../IFPRSGlobalContext';
import _ from "lodash";
import GeometryService from '../../services/GeometryService';
import DetailsProject from './DetailsProject';
import InteragencyService from '../../services/InteragencyService';
import {CalculateDefaultFundingAcres} from "../../utils/FundingHelper";
import ProjectService from "../../services/ProjectService";

const theme = createTheme({
  overrides: {
    MuiSnackbar: {
      root: {
        top: '94px !important'
      },
    },
  },
});

const useStyles = makeStyles(() => ({
  snackBarStyle: {
    top: '120px !important'
  },
}));

export default function Main({ isTreatment, feature, setFeature, mode, setMode, setIsCreatingPlannedFeature, setIsCreatingActualFeature, isNewFeature, 
  setIsNewFeature, setIsApproved, isApproved, setIsActuals, selectedFeatures, setSelectedFeatures, isActuals, setIsTreatment, setPlannedFeature, plannedFeature, 
  userInfo, userRoleInfo, setIsCompleted, setIsWithinFiscalYear, isWithinFiscalYear, setDerivationError, setDerivationErrorOpen, headerheight, rederiveFeatureInfo, 
  isProject, setIsProject, project, setProject, setIsCreatingPostFireProject, setShowMap = false, isCreatingPostFire = false, setIsCreatingPostFire = null }) {

  const { featureId } = useParams();
  const location = useLocation();
  const [plannedActualFeature, setPlannedActualFeature] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [plannedGroups, setPlannedGroups] = useState([]);
  const [plannedFunding, setPlannedFunding] = useState([]);
  const [plannedInteragencySupport, setPlannedInteragencySupport] = useState([]);
  const [estimatedActualConnection, setEstimatedActualConnection] = useState([]);
  const classes = useStyles();
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
  const nifcToken = useSelector((state) => state.configuration.nifcToken);
  const { actionCategoryAssociations, setActionCategoryAssociations, setShowGlobalLoader } = useIFPRSGlobalContext();

  useEffect(() => {
    if(!actionCategoryAssociations?.length){
      const catTypes = ActionCategoryAssociations;
      setActionCategoryAssociations(catTypes);
    }
  }, []);

  useEffect(() => {
    const getDefaultCosts = (attributes, isTreatment) => {
      const fields = FieldNames.featureFields;
      if(attributes){
        attributes[fields.estimatedAssetCost] = attributes[fields.estimatedAssetCost] ? attributes[fields.estimatedAssetCost] : 0;
        attributes[fields.estimatedContractualCost] = attributes[fields.estimatedContractualCost] ? attributes[fields.estimatedContractualCost] : 0;
        attributes[fields.estimatedGrantsFixedCost] = attributes[fields.estimatedGrantsFixedCost] ? attributes[fields.estimatedGrantsFixedCost] : 0;
        attributes[fields.estimatedOtherCost] = attributes[fields.estimatedOtherCost] ? attributes[fields.estimatedOtherCost] : 0;
        attributes[fields.estimatedPersonnelCost] = attributes[fields.estimatedPersonnelCost] ? attributes[fields.estimatedPersonnelCost] : 0;
        attributes[fields.estimatedTotalCost] = attributes[fields.estimatedTotalCost] ? attributes[fields.estimatedTotalCost] : 0;
        attributes[fields.contributedAssetCost] = attributes[fields.contributedAssetCost] ? attributes[fields.contributedAssetCost] : 0;
        attributes[fields.contributedContractualCost] = attributes[fields.contributedContractualCost] ? attributes[fields.contributedContractualCost] : 0;
        attributes[fields.contributedGrantsFixedCost] = attributes[fields.contributedGrantsFixedCost] ? attributes[fields.contributedGrantsFixedCost] : 0;
        attributes[fields.contributedOtherCost] = attributes[fields.contributedOtherCost] ? attributes[fields.contributedOtherCost] : 0;
        attributes[fields.contributedPersonnelCost] = attributes[fields.contributedPersonnelCost] ? attributes[fields.contributedPersonnelCost] : 0;
        attributes[fields.contributedTotalCost] = attributes[fields.contributedTotalCost] ? attributes[fields.contributedTotalCost] : 0;
      }
      return attributes;
    }

    const getProjectAttributes = (attributes) => {
      let projectAttributes = attributes;
      if(!attributes){
        projectAttributes = {
          [FieldNames.projectFields.fireName]: null,
          [FieldNames.projectFields.name]: null,
          [FieldNames.projectFields.wildfireAcres]: null,
          [FieldNames.projectFields.fireCode]: null,
          [FieldNames.projectFields.irwinID]: null,
          [FieldNames.projectFields.fireDiscoveryDate]: null,
          [FieldNames.projectFields.containmentDate]: null,
          [FieldNames.projectFields.ignitionFiscalYear]: null,
          [FieldNames.projectFields.id]: null,
          [FieldNames.projectFields.createdBy]: null,
          [FieldNames.projectFields.createdOnDate]: null,
          [FieldNames.projectFields.lastModifiedBy]: null,
          [FieldNames.projectFields.lastModifiedDate]: null,
          [FieldNames.projectFields.objectID]: null,
          [FieldNames.projectFields.sourceSystemID]: null,
          [FieldNames.projectFields.sourceSystemName]: null,
          [FieldNames.projectFields.notes]: null,
          [FieldNames.projectFields.entityType]: null,
          [FieldNames.projectFields.isFirePerimeter]: null,
        }
      }
      return projectAttributes;
    }

    if(location?.state?.isProject || location?.pathname?.includes("projects")){
      if (location.pathname.includes('f/projects/new') || location.pathname.includes('pf/projects/new')) {
        setIsProject(true)
        setSnackbarMessage("")
        setSnackbarOpen(false)
        setIsProject(true)
        setIsNewFeature(true)
        setIsTreatment(false);
        setMode(FieldNames.modes.edit);
        const attributes = getProjectAttributes(location.state.attributes);
        const tempObject = {
          perimeter: location.state.perimeter,
          attributes: attributes
        }
        setFeature(tempObject);
        setProject(tempObject)
        if(location && location.state && location.state.error){
          setDerivationError(location.state.error);
          setDerivationErrorOpen(true);
        }
        setIsCreatingPlannedFeature(false);
        setIsActuals(false);
        emitCustomEvent(Events.SetActualIsNew, false);
        emitCustomEvent(Events.SetActualIsTreatment, false);
        emitCustomEvent(Events.SetWFFTSAttributes, null);
        emitCustomEvent(Events.DisableNewActualIcons, true);
        setShowGlobalLoader(false);
        emitCustomEvent(Events.DisableProjectCreate, false);
      } else {
        setIsProject(true)
        setSnackbarMessage("")
        setSnackbarOpen(false)
        if(location?.pathname?.includes('/projects/') && featureId){
          setMode(FieldNames.modes.read);
          setIsNewFeature(false);
          setIsProject(true)
          ProjectService.getProjectByObjectID(featureId).then(async(existingProject) => {
            emitCustomEvent(Events.ZoomTo, existingProject.geometry);
            emitCustomEvent(Events.HighlightExistingFeature, {feature: existingProject, isPostFire: true, isProject: true});
            setFeature(existingProject);
            setProject(existingProject)
            if(existingProject?.attributes?.[FieldNames.projectFields.isFirePerimeter] === FieldNames.yesNo.yes){
              setMode(FieldNames.modes.read);
            } 
            setShowGlobalLoader(false);
            emitCustomEvent(Events.DisableProjectCreate, false);
            if(location.state?.error){
              setSnackbarOpen(true)
              setSnackbarMessage(location.state?.error)
              setSnackbarSeverity("warning")
            } else if(location.state?.message) {
              setSnackbarOpen(true)
              setSnackbarMessage(location.state?.message)
              setSnackbarSeverity("success")
            }
          })
        }
      }
      
    } else {
      if (location.pathname.includes('/treatments/new') || location.pathname.includes('/activities/new')) {
        setShowGlobalLoader(true);
        const isCurrentTreatment = location.pathname.includes('/treatments/new') ? true : false;
        const isCurrentActual = location.state.isActual ?? false;
        setIsProject(false)
        setIsNewFeature(true);
        setIsTreatment(isCurrentTreatment);
        setMode(FieldNames.modes.edit);
        if(!isCurrentActual)
        {
          //On Estimated when we copy from wffts and legacy we don't pull in anything other than the shape
          const attributes = getDefaultCosts(location.state.attributes, isCurrentTreatment);
          attributes[FieldNames.featureFields.class] = isCurrentTreatment ? 
                                                        (isCurrentActual ? FieldNames.classTypes.actualTreatment : FieldNames.classTypes.treatment) : 
                                                        (isCurrentActual ? FieldNames.classTypes.actualActivity : FieldNames.classTypes.activity);
          if(project){
            attributes[FieldNames.featureFields.projectID] = project.attributes[FieldNames.projectFields.id]
            attributes[FieldNames.featureFields.projectName] = project.attributes[FieldNames.projectFields.name]
            attributes[FieldNames.featureFields.projectFireName] = project.attributes[FieldNames.projectFields.fireName]
            attributes[FieldNames.featureFields.wildfireAcres] = project.attributes[FieldNames.projectFields.wildfireAcres]
            attributes[FieldNames.featureFields.fireCode] = project.attributes[FieldNames.projectFields.fireCode]
            attributes[FieldNames.featureFields.irwinID] = project.attributes[FieldNames.projectFields.irwinID]
            attributes[FieldNames.featureFields.fireDiscoveryDate] = project.attributes[FieldNames.projectFields.fireDiscoveryDate]
            attributes[FieldNames.featureFields.containmentDate] = project.attributes[FieldNames.projectFields.containmentDate]
            attributes[FieldNames.featureFields.ignitionFiscalYear] = project.attributes[FieldNames.projectFields.ignitionFiscalYear]
            attributes[FieldNames.featureFields.projectNotes] = project.attributes[FieldNames.projectFields.notes]
            attributes[FieldNames.featureFields.projectEntityType] = project.attributes[FieldNames.projectFields.entityType]
            attributes[FieldNames.featureFields.isFirePerimeter] = project.attributes[FieldNames.projectFields.isFirePerimeter]

          }
          const tempObject = {
            perimeter: location.state.perimeter,
            attributes: attributes
          }
          setFeature(tempObject);
          if(location && location.state && location.state.error){
            setDerivationError(location.state.error);
            setDerivationErrorOpen(true);
          }
          setIsCreatingPlannedFeature(false);
          setIsActuals(false);
          emitCustomEvent(Events.SetActualIsNew, false);
          emitCustomEvent(Events.SetActualIsTreatment, isCurrentTreatment);
          emitCustomEvent(Events.SetWFFTSAttributes, null);
          emitCustomEvent(Events.DisableNewActualIcons, true);
          setShowGlobalLoader(false);
        }
        else
        {
          //Creating a new actual, it always builds off of the planned
          setIsCreatingActualFeature(false);
          setIsActuals(true);
          emitCustomEvent(Events.SetActualIsNew, true);
          emitCustomEvent(Events.SetActualIsTreatment, isCurrentTreatment);
          emitCustomEvent(Events.SetWFFTSAttributes, null);
          emitCustomEvent(Events.SetLegacyAttributes, null);
          // We already have this data for actuals. Rework the below to use it in 1.6 or beyond.
          // const tempObject = {
          //   perimeter: location.state.perimeter,
          //   attributes: location.state.attributes
          // }
          let plannedObjectID = location?.state?.plannedObjectID;
          const actualAttr = location?.state?.attributes;

          if(plannedObjectID && actualAttr){
            window.api.getActionByObjectID(plannedObjectID, actualAttr[FieldNames.featureFields.joinFeature]).then(async(plannedFeature) => 
            {
              setEstimatedActualConnection([])
              if(plannedFeature){
                if(plannedFeature.attributes && plannedFeature.attributes[FieldNames.featureFields.hasGroup] === FieldNames.yesNo.yes){
                  let groupsForPlanned = [];
                  groupsForPlanned = await getPlannedGroups(plannedFeature.attributes[FieldNames.featureFields.joinID], plannedFeature.attributes[FieldNames.featureFields.joinFeature]);
                  setPlannedGroups(groupsForPlanned);
                }
                if(plannedFeature.attributes){
                  //Only need to know this when first creating the actual
                  let fundingForPlanned = [];
                  fundingForPlanned = await getPlannedFunding(plannedFeature.attributes[FieldNames.featureFields.joinID], plannedFeature.attributes[FieldNames.featureFields.joinFeature]);
                  const area = (actualAttr[FieldNames.featureFields.joinFeature] !== 'Polygon' || actualAttr[FieldNames.featureFields.isPoint] === FieldNames.yesNo.yes) ? 0 : actualAttr[FieldNames.featureFields.calculatedArea];
                  setPlannedFunding(CalculateDefaultFundingAcres(fundingForPlanned, area));

                  let interagencySupportForPlanned = [];
                  interagencySupportForPlanned = await getPlannedInteragencySupport(plannedFeature.attributes[FieldNames.featureFields.joinID], plannedFeature.attributes[FieldNames.featureFields.joinFeature]);
                  setPlannedInteragencySupport(interagencySupportForPlanned);
                  //No need to check for Actual Funding items since the Actual isn't created yet
                }
                setPlannedFeature(plannedFeature);
                const tempObject = {
                  perimeter: location.state.perimeter,
                  attributes: location.state.attributes
                }
                if(location && location.state && location.state.error){
                  setDerivationError(location.state.error);
                  setDerivationErrorOpen(true);
                }
                let tempFeature = Object.assign({}, tempObject);
                //Moving to the same method
                tempFeature.attributes = createFutureActualFeature(tempFeature?.attributes, plannedFeature.attributes, isCurrentTreatment, userInfo);
                setFeature(tempFeature);
                setShowGlobalLoader(false);
              }
            }
            ).catch(err => {
              setShowGlobalLoader(false);
              setSnackbarOpen(true);
              if(err && err.errorMessage){
                setSnackbarMessage(err.errorMessage);
              } else {
                setSnackbarMessage(`There was an error getting the new estimated ${isCurrentTreatment ? 'treatment' : 'activity'} template`)
              }
            });
          }
        }    
      }
  
      if(location && location.pathname && (location.pathname.includes("/treatments/") || location.pathname.includes("/activities/")) && (!location.pathname.includes("new"))){
        setShowGlobalLoader(true);
        setIsProject(false)
        let isTreatment = location.pathname.includes("/treatments/");
        const isCurrentActualFromState = location?.state?.isActual ?? false;
        let fields = FieldNames.featureFields;
        //Only gets the Action from the concatenated funding view
        window.api.getActionByID(featureId).then(f => {
          if(f){
            //Now returns both the ID and OBJECTID along with the geometry
            GeometryService.getGeometryByIDType(f.attributes[FieldNames.featureFields.joinID], f.attributes[FieldNames.featureFields.joinFeature]).then(geo => {
              setShowGlobalLoader(false);
              if(geo){
                f.geometry = geo.geometry;
                //We have to assume that class already exists
                const isCurrentTreatment = (f.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || f.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
                const internalEntityType = isFeaturePostFire(f.attributes) ? FieldNames.internalEntityTypes.postFire : FieldNames.internalEntityTypes.fuels;
                const isCurrentActual = (f.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity || f.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
                emitCustomEvent(Events.ZoomTo, f.geometry);
                emitCustomEvent(Events.HighlightExistingFeature, {feature: f, isPostFire: isFeaturePostFire(f.attributes), isProject: false});
                //Using this since the Concatenated view doesn't have the geometry objectID on it
                f.attributes[FieldNames.featureFields.joinObjectID] = geo.attributes.OBJECTID;
                setIsNewFeature(false);
                setFeature(f);
                setIsTreatment(isCurrentTreatment);

                if(!isCurrentActual)
                {
                  const attributes = getDefaultCosts(f.attributes, isTreatment);
                  if(!attributes[fields.entityType]){
                    attributes[fields.entityType] = internalEntityType;
                  }
                  f.attributes = _.cloneDeep(attributes);
                  if(attributes && attributes[fields.hasActual] === FieldNames.yesNo.yes){
                    const whereClauseStr = `(${FieldNames.estimatedActuals.joinIDE} = ${attributes[FieldNames.featureFields.id]}) AND (${FieldNames.estimatedActuals.joinFeatureE} = '${attributes[FieldNames.featureFields.joinFeature]}') AND (IsArchived = 'No' OR IsArchived IS NULL)`;
                    PlannedActualsService.getAllPlannedActualRecords(whereClauseStr).then((connectedActual) => {
                      setEstimatedActualConnection(connectedActual);
                    }).catch(error => {
                      ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
                    });
                  }
                  setPlannedFeature(null);
                  setIsActuals(false);
                }
                else
                {
                  setIsActuals(isCurrentActual);
                  emitCustomEvent(Events.SetActualIsNew, false);
                  emitCustomEvent(Events.SetActualIsTreatment, isCurrentTreatment);
                  PlannedActualsService.getPlannedActualsByJoinIDs(f.attributes[FieldNames.featureFields.joinFeature], [f.attributes[FieldNames.featureFields.joinID]], true).then(response => {
                    if(response && response.length > 0){
                      setPlannedActualFeature(response[0]);
                      const plannedJoinID = response[0].attributes[FieldNames.estimatedActuals.joinIDE];
                      const plannedJoinFeature = response[0].attributes[FieldNames.estimatedActuals.joinFeatureE];
                      if(plannedJoinID){
                        window.api.getActionByJoinValues(plannedJoinID, plannedJoinFeature).then(plannedFeature => 
                        {
                          setPlannedFeature(plannedFeature);
                        }
                        ).catch(err => {
                          setSnackbarOpen(true);
                          if(err && err.errorMessage){
                            setSnackbarMessage(err.errorMessage);
                          } else {
                            setSnackbarMessage("There was an error getting planned")
                          }
                        });
                      } 
                      //What should we do if there isn't a join entry - meaning this is an orphaned Actual
                    }
                  }).catch(error => {
                    ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
                  });
                }
              } else {
                setShowGlobalLoader(false);
                throw new Error("Unable to find Geometry attached to the Action");
              }
            })
          }
          else
          {
            setShowGlobalLoader(false);
            throw new Error("Unable to find Action");
          }
        }).catch(err => {
          setShowGlobalLoader(false);
          setSnackbarOpen(true);
          if(err && err.errorMessage){
            setSnackbarMessage(err.errorMessage);
          } else {
            setSnackbarMessage(`There was an error getting the requested Estimated ${isTreatment ? `Treatment` : `Activity`}`)
          }
        });
      }
    }

    const getPlannedFunding = async(joinID, joinFeature) => {
      return FundingService.getFundingByJoinIDs([joinID], joinFeature).catch(error => {
        ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
      });
    }

    const getPlannedGroups = async(joinIDs, joinFeature) => {
      return GroupingService.getAllGroupItemsForFeatures([joinIDs], joinFeature).catch(error => {
        ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
      });
    }

    const getPlannedInteragencySupport = async(joinID, joinFeature) => {
      return InteragencyService.getAllInteragencyByJoinIDFeature(joinID, joinFeature).catch(error => {
        ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
      });
    }
  }, [
    location, 
    featureId, 
    setFeature, 
    setIsCreatingPlannedFeature, 
    setIsCreatingActualFeature,
    setIsNewFeature,
    setMode,
    setIsActuals,
    setPlannedFeature,
    config,
    nifcToken,
    rootServiceUrl,
    setDerivationError,
    setDerivationErrorOpen,
    userInfo,
    setIsTreatment
  ]);

  const toggleContainer = () => {
    if(isProject && feature){
      return (
        <div className="content-container content-container-details" style={{ height: '100vh'}}>
          <DetailsProject 
            project={project}
            setProject={setProject}
            mode={mode}
            setMode={setMode}
            headerheight={headerheight}
            userInfo={userInfo}
            userRoleInfo={userRoleInfo}
            setShowMap={setShowMap}
            isCreatingPostFire={isCreatingPostFire}
            setIsCreatingPostFire={setIsCreatingPostFire}
            setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
            setIsTreatment={setIsTreatment} 
            feature={feature}
            setFeature={setFeature}
            isNew={isNewFeature}
            setIsNew={setIsNewFeature}
            setIsCreatingPostFireProject={setIsCreatingPostFireProject}
          />
        </div>
      )
    } else {
      if(isActuals && plannedFeature && feature){
        return (
          <div className="content-container content-container-details" style={{ height: '100vh'}}>
            <DetailsActualsContainer 
              isTreatment={isTreatment} 
              feature={feature} 
              mode={mode} 
              setMode={setMode} 
              isNewFeature={isNewFeature} 
              setIsNewFeature={setIsNewFeature} 
              setFeature={setFeature}
              selectedFeatures={selectedFeatures}
              setSelectedFeatures={setSelectedFeatures}
              plannedFeature={plannedFeature}
              plannedActualFeature={plannedActualFeature}
              setIsCompleted={setIsCompleted}
              setIsWithinFiscalYear={setIsWithinFiscalYear}
              isWithinFiscalYear={isWithinFiscalYear}
              userInfo={userInfo}
              userRoleInfo={userRoleInfo}
              headerheight={headerheight}
              rederiveFeatureInfo={rederiveFeatureInfo}
              plannedGroups={plannedGroups}
              plannedFunding={plannedFunding}
              plannedInteragencySupport={plannedInteragencySupport}
              geometryType={feature?.attributes[FieldNames.featureFields.joinFeature]}

            />
          </div>
        )
      } else if(!isActuals && feature) {
        return (
          <div className="content-container content-container-details">
            <DetailsContainer 
              isTreatment={isTreatment} 
              feature={feature}
              setFeature={setFeature}
              mode={mode} 
              setMode={setMode} 
              isNewFeature={isNewFeature} 
              setIsNewFeature={setIsNewFeature} 
              setIsApproved={setIsApproved} 
              isApproved={isApproved}
              setIsTreatment={setIsTreatment}
              setIsCreatingActualFeature={setIsCreatingActualFeature}
              setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
              setPlannedFeature={setPlannedFeature}
              setSelectedFeatures={setSelectedFeatures}
              userInfo={userInfo}
              userRoleInfo={userRoleInfo}
              headerheight={headerheight}
              rederiveFeatureInfo={rederiveFeatureInfo}
              estimatedActualConnection={estimatedActualConnection}
              project={project}
              setProject={setProject}
            />
          </div>
        )
      }
    }
  }
  return (
    <div className="content-container content-container-details">
      {toggleContainer()}
      <div style={{ top: 64 }}>
        <ThemeProvider theme={theme}>
          <Snackbar open={snackbarOpen} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            className={classes.snackBarStyle}
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }}>
            <Alert onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }} severity={snackbarSeverity} sx={{ width: '100%' }}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </ThemeProvider>
      </div>
    </div>
  )
}